import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { INITIAL_LOADING } from '~/actions';
import useLoading from '~/hooks/useLoading';
import { useUserSelector } from '~/hooks/useUserSelector';
import { routes } from '~/routes';
import { useIsWorkerClassificationEnabled } from '~/selectors';
import { inferRedirectTarget } from '../../RegistrationRedirect';

const STEP_ORDER: readonly string[] = [
  routes.signUpRedesign.yourInfo,
  routes.signUpRedesign.officeDetails,
  routes.signUpRedesign.officeSetup,
  routes.signUpRedesign.workerType,
];

export type TSignUpStepRoute = (typeof STEP_ORDER)[number];

export const useRequireSignUpStep = (currentRoute: TSignUpStepRoute) => {
  const navigate = useNavigate();
  const user = useUserSelector();
  const isWorkerClassificationEnabled = Boolean(useIsWorkerClassificationEnabled());
  const { isLoading: isInitialLoading } = useLoading([INITIAL_LOADING]);

  useEffect(() => {
    if (isInitialLoading) return;
    if (!user) {
      navigate(routes.signUpRedesign.signUp, { replace: true });
      return;
    }
    const target = inferRedirectTarget(user, { isWorkerClassificationEnabled });
    const currentIdx = STEP_ORDER.indexOf(currentRoute);
    const targetIdx = STEP_ORDER.indexOf(target);

    if (targetIdx === -1) {
      navigate(target, { replace: true });
      return;
    }

    if (currentIdx > targetIdx) {
      navigate(target, { replace: true });
    }
  }, [user, isWorkerClassificationEnabled, currentRoute, navigate, isInitialLoading]);
};
